import { type LucideIcon, PanelTopOpen } from 'lucide-react';

export const DropDownIcon: LucideIcon = PanelTopOpen;
